import { BarChart3 } from "lucide-react";
import { PageHeader } from "@/components/Layout/PageHeader";
import { CoverageAnalyticsView } from "./CoverageAnalyticsView";

export function CoverageAnalyticsPage() {
  return (
    <div>
      <PageHeader
        icon={BarChart3}
        title="Coverage Analytics"
        description="Measure how your stories and press releases are performing across media channels. Score journalist coverage quality, track beat trends, and identify your most impactful contributors."
      />
      <CoverageAnalyticsView />
    </div>
  );
}
